module.exports = __webpack_public_path__ + "static/media/welcome_party_logo_main.6a759528.png";